import { useEffect, useState } from 'react';
import Loading from '../../Loading';
import Select from '../../Select';
import { useBusinessInfo } from '../../../lib/Queries';
import useBusinessPostApi from '../../../lib/useBusinessPostApi';
import type { Currency } from './Payment.types';

const CurrencySettings = () => {
    const { data, isLoading } = useBusinessInfo();
    const [currency, setCurrency] = useState<Currency>('USD');
    const { save } = useBusinessPostApi(`/integrations/payments/currency`);

    useEffect(() => {
        setCurrency(data?.business?.currency);
    }, [data?.business?.currency]);

    function updateCurrency(newCurrency: string) {
        setCurrency(newCurrency as Currency);
        save({ currency: newCurrency });
    }

    return (
        <div>
            {isLoading && <Loading />}
            {!isLoading && (
                <Select
                    value={currency}
                    onChange={updateCurrency}
                    options={{
                        USD: 'United States Dollar ($)',
                        GBP: 'United Kingdom Pound (£)',
                        NZD: 'New Zealand Dollar (NZD $)',
                        AUD: 'Australian Dollar (AUD $)',
                        CAD: 'Canadian Dollar (CAD $)',
                        EUR: 'Euro (€)',
                        CZK: 'Czech koruna (Kč)',
                        CHF: 'Swiss Franc (CHF)',
                        DKK: 'Danish Krone (kr)',
                        ZAR: 'South African Rand (R)',
                        THB: 'Thai Baht (฿)',
                        HKD: 'Hong Kong Dollar (HK$)',
                        SEK: 'Swedish Krona (kr)',
                        PHP: 'Philippine Peso (₱)',
                    }}
                />
            )}
        </div>
    );
};
export default CurrencySettings;
